import {
  asyncRequest,
  getComponentConfig,
  registerComponent,
  replaceDOM,
} from "helpers";

registerComponent(
  "product-recommendations",
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      this.config = getComponentConfig(this);
      const observer = new IntersectionObserver(this.handleIntersection, {
        rootMargin: "0px 0px 200px 0px",
      });

      observer.observe(this);
    }

    handleIntersection = async (entries, observer) => {
      if (!entries[0].isIntersecting) {
        return;
      }

      observer.unobserve(this);

      const html = await asyncRequest(this.config.endpoint);

      replaceDOM(
        html,
        `[data-product-recommendations="${this.config.sectionID}"]`,
      );
    };
  },
);
